// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-chat-info .conference-system-data {\n  padding-right: 0;\n  color: #fff;\n}\n.no-chat-info .conference-system-data__title {\n  margin-bottom: 30px;\n  font-weight: bold;\n}\n.no-chat-info .conference-system-data__title,\n.no-chat-info .conference-system-data__data-title {\n  color: #fff;\n}\n.no-chat-info .no-chat-info__link {\n  text-decoration: underline;\n}\n.no-chat-info .no-chat-info__link:hover {\n  opacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
